<template>
  <div class="kmlTable">
    <table>
      <template v-for="kml in kmlEntries" :key="kml.index">
        <tr>
          <td>
            <q-checkbox v-model="kml.active" @update:model-value="toggleRendering(kml)" load></q-checkbox>
          </td>
          <td>
            <div style="font-weight: bold; font-size: 12px">{{ kml.fileName }}</div>
            <div style="font-size: 12px">{{ kml.desc }}</div>
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

// import GeoXML3 from '/src/components/charts/lib/geoxml3.js'
import createTextOverlay from "components/plugins/gmap/TextOverlay";
import CSVHelper from "src/classes/CSVHelper";

export default {
  name: 'kmlSideMenu',
  props: ['map', 'zoom', 'kmlFileDir', 'queryResult', 'setupToken'],
  components: {},

  data() {
    return {
      myParser: null,
      showKML: false,
      kmlEntries: [],
      currentParseIndex: 0,
      pendingParseCount: 0,
      usedZoom: false,
      storedActiveEntries: null,
      textCreator: null
    }
  },

  methods: {
    init() {
      this.kmlEntries = null;
      this.textCreator = createTextOverlay(google)

      let mySetupToken = CSVHelper.getObjectArrayFromCSV(this.setupToken)
      this.showRegionNames = mySetupToken.showRegionNames

      axios.get(getHost() + "/servlets/kmlDirectoryServlet?path=" + this.kmlFileDir)
        .then(resp => {
          this.kmlEntries = resp.data.files.map((x, index) => {
            return {
              index: index,
              active: (x.active.toLowerCase() === 'true'),
              desc: x.description,
              fileName: x.name,
              parserIndex: -1,
              doc: null
            }
          })

          if (this.queryResult && this.queryResult.length > 0) {
            // only check queryResult if there is a geo_region_name which indicates if a area is active or not
            if (Object.keys(this.queryResult[0]).includes("geo_region_name")) {
              for (let idx = 0; idx < this.queryResult.length; idx++) {
                let row = this.queryResult[idx]
                let foundKml = this.kmlEntries.find(entry => // {
                  entry.fileName.toLowerCase().replace(".kml", "") === row.geo_region_name.toLowerCase()
                )
                if (foundKml) {
                  foundKml.active = true
                  if (row.geo_cardcode) foundKml.color = row.geo_cardcode
                  if (row.geo_region_info) foundKml.info = row.geo_region_info
                  if (row.geo_region_name) foundKml.regionName = row.geo_region_name
                  if (row.geo_region_lbl_ycorr) foundKml.geo_region_lbl_ycorr = row.geo_region_lbl_ycorr
                  else foundKml.geo_region_lbl_ycorr = 0
                }
              }
            }

          } else if (this.storedActiveEntries) {
            this.kmlEntries.forEach(x => {
              x.active = false
            })
            this.storedActiveEntries.forEach(act => {
              let foundKml = this.kmlEntries.find(entry => entry.fileName == act)
              if (foundKml) {
                foundKml.active = true
              }
            })
          }

          this.myParser = new geoXML3.parser({
            map: this.map,
            processStyles: true,
            zoom: this.usedZoom,
            failedParse: this.showInvalidKml,
            afterParse: this.postParse,
            suppressInfoWindows: true  // Disable the automatic InfoWindow
          });
          this.parsePreselected()
        })
        .catch(error => {
          console.error(error)
          this.eventBus.globalErrorHandling("Fehler beim Lesen der KML Dateienliste.", {message: "Überprüfen Sie den Ordnerpfad."})
          this.$emit("show-kml-error", "Fehler beim Lesen der KML Dateienliste.")
        })
    },

    postParse(docset) {
      this.pendingParseCount--;
      if (this.pendingParseCount === 0) this.$q.loading.hide()

      let kmlIndex = docset[0].url.substr(docset[0].url.indexOf("idx=") + 4)
      let color = this.kmlEntries[kmlIndex].color
      let info = this.kmlEntries[kmlIndex].info

      if (docset[0].gpolygons) {
        for (var i = 0; i < docset[0].gpolygons.length; i++) {
          let polygon = docset[0].gpolygons[i]
          polygon.setOptions({
            fillColor: color, // Farbe des Inneren des Polygons
            fillOpacity: 0.5 // Deckkraft des Inneren des Polygons
            // strokeColor: 'green', // Farbe des Randes des Polygons
            // strokeWeight: 2 // Breite des Randes des Polygons
          })
        }
      }

      if (info) {
        let polygon = docset[0].gpolygons[0]; // Assuming the first polygon
        let coordinates = polygon.getPath().getArray(); // Get the coordinates of the polygon
        let totalLat = 0;
        let totalLng = 0;

        for (var i = 0; i < coordinates.length; i++) {
          totalLat += coordinates[i].lat();
          totalLng += coordinates[i].lng();
        }

        let centerLat = totalLat / coordinates.length;
        let centerLng = totalLng / coordinates.length;

        let infoWindow = new google.maps.InfoWindow({content: info, disableAutoPan: true});
        let centerPoint = new google.maps.LatLng(centerLat, centerLng);
        infoWindow.setPosition(centerPoint);

        // console.log("entries:", this.kmlEntries[kmlIndex])
        if (this.showRegionNames && this.kmlEntries[kmlIndex].regionName) {
          let regionNameCenterPoint = new google.maps.LatLng(parseFloat(centerLat) - parseFloat(this.kmlEntries[kmlIndex].geo_region_lbl_ycorr), centerLng)
          new this.textCreator(regionNameCenterPoint, "<div>" + this.kmlEntries[kmlIndex].regionName + "</div>", "customBox", this.map)
        }

        google.maps.event.addListener(polygon, 'mouseover', function () {
          infoWindow.open({map: this.map, shouldFocus: false});
        })
        google.maps.event.addListener(polygon, 'mouseout', function () {
          infoWindow.close();
        })
        google.maps.event.addListener(polygon, "click", function () {
          // Do nothing (or whatever you want) on click
        });
      }
    },

    showInvalidKml(doc) {
      doc.layer.active = false;
    },

    toggleRendering(kml) {
      if (kml) {
        if (kml.active) {
          if (kml.parserIndex == -1) {
            this.$q.loading.show()
            this.pendingParseCount++;
            setTimeout(() => {
              this.parse(kml)
            }, 200)

          } else {
            setTimeout(() => {
              this.myParser.showDocument(kml.doc)
            }, 200)
          }
        } else {
          if (kml.parserIndex != -1) {
            setTimeout(() => {
              this.myParser.hideDocument(kml.doc)
            }, 200)
          }
        }
      }
      this.storedActiveEntries = this.kmlEntries.filter(x => x.active).map(k => k.fileName)
      localStorage.setItem(this.$route.params.id + "_storedKML", JSON.stringify(this.storedActiveEntries));
    },

    parsePreselected() {
      this.$q.loading.show()
      let active = false
      let delay = 200;

      this.kmlEntries.forEach((kml) => {
        if (kml.active) {
          setTimeout(() => {
            this.parse(kml)
          }, delay)
          this.pendingParseCount++;
          active = true
        }
        delay += 200
      })
      if (!active) this.$q.loading.hide()
    },

    parse(kml) {
      kml.parserIndex = this.currentParseIndex
      //console.log("parse:", kml.index, kml.fileName)
      this.myParser.parse(getHost() + "/servlets/kmlDirectoryServlet?path=" + this.kmlFileDir + "&idx=" + kml.index, kml)
      //console.log("parse done.", kml.fileName, kml.index, kml.doc)
      this.currentParseIndex++
    }
  },

  beforeUnmount: function () {
    this.myParser = null
    this.kmlEntries = null
  },

  async mounted() {
    if (typeof this.zoom !== "undefined") {
      this.usedZoom = this.zoom
    }
    let storedKML = localStorage.getItem(this.$route.params.id + "_storedKML");
    if (storedKML) {
      this.storedActiveEntries = safeParseJSON(storedKML)
    }
    this.init()
  }
}

</script>

<style lang="sass">
.kmlTable
  max-height: 30vh
  overflow: auto
  width: 100%

</style>
